import { useNavigate } from '@tanstack/react-router'
import { useAtom, useAtomValue } from 'jotai'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Button,
} from '@duck/ui'
import { ClipboardList } from 'lucide-react'
import {
  isYouHaveAssignmentsDialogOpenAtom,
  userAtom,
  youHaveAssignmentsOrganizationNameAtom,
} from '@/store/userAtoms'
import { TypedTrans, useTar } from '@/modules'
import { useLocalSettings } from '@/hooks/useLocalSettings'

export const YouHaveAssignmentsDialog = () => {
  const navigate = useNavigate()
  const { t } = useTar()
  const [isOpen, setIsOpen] = useAtom(isYouHaveAssignmentsDialogOpenAtom)
  const [organizationName] = useAtom(youHaveAssignmentsOrganizationNameAtom)
  const { setSetting } = useLocalSettings()
  const user = useAtomValue(userAtom)
  const lastLoginAt = user?.lastLoginAt ?? null

  if (!isOpen) {
    return null
  }

  const handleClose = () => {
    setIsOpen(false)

    if (lastLoginAt) {
      setSetting('dismissedGoToAssignments', lastLoginAt)
    }
  }

  const handleGoToAssignments = () => {
    navigate({ to: '/assignments' })
    setIsOpen(false)

    if (lastLoginAt) {
      setSetting('dismissedGoToAssignments', lastLoginAt)
    }
  }

  const description = organizationName
    ? (
      <TypedTrans
        i18nKey="common.youHaveOpenAssignmentFromOrg"
        components={[
          <span key="org-name" className="text-primary">
            {organizationName}
          </span>,
        ]}
      />
    )
    : t('common.youHaveOpenAssignmentGeneric')

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent width="sm" noMinHeight showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>
            {t('common.youHaveOpenAssignmentTitle')}
          </DialogTitle>
          <div className="flex gap-3 mt-8">
            <div className="mt-8">
              <ClipboardList className="h-6 w-6 text-primary" />
            </div>
            <div className="mt-6">
              <DialogDescription>
                {description}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="mt-6 flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={handleClose}
          >
            {t('common.dismissUntilNextLogin')}
          </Button>
          <Button
            onClick={handleGoToAssignments}
          >
            {t('common.goToAssignments')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

